import storeModule from './store'

let config

const validateOptions = (options) => {
  if (!options.store) throw new Error('Please provide a Vuex store')

  return options
}

const registerStoreModule = () => {
  config.store.registerModule('activityNotes', storeModule)
}

export default {
  install (Vue, options) {
    config = validateOptions(options)
    Vue.prototype.$_activityNotes_config = config
    registerStoreModule()
  }
}



// WEBPACK FOOTER //
// ./~/vue-components/activity-notes/index.js